// extracted by mini-css-extract-plugin
module.exports = {"svg":"ReconnectPopup_svg___wd9w","body":"ReconnectPopup_body__2_yCA","mobile":"ReconnectPopup_mobile__219xo"};